var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTicketFill = function SvgTicketFill(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.50006 6.00012C4.50006 4.34327 5.84321 3.00012 7.50006 3.00012H16.5001C18.1569 3.00012 19.5001 4.34327 19.5001 6.00012V18.0001C19.5001 19.657 18.1569 21.0001 16.5001 21.0001H7.50006C5.84321 21.0001 4.50006 19.657 4.50006 18.0001V6.00012ZM15.0001 9.00012H9.00006V7.50012H15.0001V9.00012ZM9.00006 12.0001H15.0001V10.5001H9.00006V12.0001Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.50006 6.00012C4.50006 4.34327 5.84321 3.00012 7.50006 3.00012H16.5001C18.1569 3.00012 19.5001 4.34327 19.5001 6.00012V18.0001C19.5001 19.657 18.1569 21.0001 16.5001 21.0001H7.50006C5.84321 21.0001 4.50006 19.657 4.50006 18.0001V6.00012ZM15.0001 9.00012H9.00006V7.50012H15.0001V9.00012ZM9.00006 12.0001H15.0001V10.5001H9.00006V12.0001Z",
    fill: "currentColor",
    fillOpacity: 0.2
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTicketFill);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "ticket-fill.6877392dda4583f0cc5857cab44595be.svg";